import React from 'react';
import { FormItem } from './form-item';
// TODO need to add this as component which can handle
// onSubmission and onCancel callback handler
export const Form = ({ children, ...restProps }) => {
    return React.createElement("form", { ...restProps }, children);
};
Form.Item = FormItem;
/**
 * <Form>
 *      <Form.Item>Any Input like text / dropdown </Form.Item>
 *      <Form.Item>Any Input like text / dropdown </Form.Item>
 * </Form>
 */
//# sourceMappingURL=index.js.map